module["exports"] = [
  "Lgh. ###",
  "Hus ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/secondary_address.js
// module id = 1704
// module chunks = 0